import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import SweetAlert from 'react-bootstrap-sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrashAlt,
  faCalendarAlt,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import api from 'services/api';

import { ButtonPanel, ManagerList } from './styles';

import Button from 'components/Button';
import Input from 'components/Input';
import Loading from 'components/Loading';

export default class EventDetail extends Component {
  state = {
    alert: {},
    event: {},
    loading: true,
    showAlert: false,
  };

  static propTypes = {
    match: PropTypes.shape().isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  roleTranslation = {
    owner: 'Criador',
    admin: 'Administrador',
    manager: 'Gerente',
  };

  componentDidMount() {
    this.loadEvent();
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  loadEvent = async () => {
    try {
      const { id } = this.props.match.params;
      const { data } = await api.get(`admin/events/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      data.event.producers = data.event.producers.map(producer => ({
        ...producer,
        translated_role: this.roleTranslation[producer.role],
      }));
      data.event.finishable = Date.parse(data.event.end_at) < Date.now();
      data.event.start_at = moment(data.event.start_at).format(
        'D [de] MMMM [de] YYYY, HH:mm[h]',
      );
      data.event.end_at = moment(data.event.end_at).format(
        'D [de] MMMM [de] YYYY, HH:mm[h]',
      );
      data.event.last_post_date = data.event.last_post_date
        ? moment(data.event.last_post_date).format(
            'D [de] MMMM [de] YYYY, HH:mm[h]',
          )
        : null;

      this.setState({ event: data.event, loading: false });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: [
              'Não foi possível carregar o evento. Por favor, atualize a página e tente novamente.',
            ],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  acceptEvent = async id => {
    try {
      await api.put(
        `admin/events/${id}`,
        { approval_status: 'approved' },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
          },
        },
      );

      this.closeAlert();
      this.props.history.push('/admin/dashboard/events');
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Erro ao aceitar evento, por favor atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  rejectEvent = async id => {
    try {
      await api.put(
        `admin/events/${id}`,
        { approval_status: 'rejected' },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
          },
        },
      );

      this.closeAlert();
      this.props.history.push('/admin/dashboard/events');
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Erro ao rejeitar evento, por favor atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  deleteEvent = id => {
    this.setState(
      {
        alert: {
          title: 'Tem certeza que deseja deletar o evento?',
          type: 'warning',
          messages: [
            'Todas as informações serão apagadas permanentemente e o evento não aparecerá em seu histórico.',
          ],
          confirmBtnText: 'Deletar',
          confirmBtnBsStyle: 'danger',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmDeleteEvent(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmDeleteEvent = async id => {
    try {
      await api.delete(`admin/events/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      this.closeAlert();
      this.props.history.push('/admin/dashboard/events');
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Erro ao deletar evento, por favor atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  render() {
    const {
      approval_status,
      active_promoters,
      address,
      benefits,
      cover,
      end_at,
      extra,
      last_post_date,
      min_followers,
      name,
      place,
      producers,
      rules,
      segment,
      slots,
      start_at,
      status,
      whatsapp_link,
    } = this.state.event;

    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      loading,
      managerEmail,
      showAlert,
    } = this.state;

    const eventId = this.props.match.params.id;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Fragment>
            <div className="row">
              <div className="col-12">
                {status !== 'active' && (
                  <h2 className="page-title inline">Evento finalizado</h2>
                )}
                <ButtonPanel>
                  <div className="end-buttons align-right">
                    {approval_status === 'pending' && (
                      <Fragment>
                        <Button
                          onClick={() => this.acceptEvent(eventId)}
                          className="btn-success"
                        >
                          Aceitar evento
                        </Button>
                        <Button
                          onClick={() => this.rejectEvent(eventId)}
                          className="btn-danger"
                        >
                          Rejeitar evento
                        </Button>
                      </Fragment>
                    )}
                    {approval_status !== 'pending' && (
                      <Link
                        to={`/admin/dashboard/events/${eventId}/report`}
                        className="btn btn-primary"
                      >
                        Relatório de participação
                      </Link>
                    )}
                    {approval_status !== 'pending' && (
                      <Button
                        onClick={() => this.deleteEvent(eventId)}
                        className="btn-danger"
                      >
                        Deletar evento
                      </Button>
                    )}
                  </div>
                </ButtonPanel>
              </div>
            </div>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  <div className="card card-big">
                    {cover && (
                      <div
                        className="card-image"
                        style={{
                          backgroundImage: `url(${cover})`,
                        }}
                      />
                    )}
                    <div className="card-block">
                      <h4 className="card-title">{name}</h4>
                      {address && (
                        <p className="card-text">
                          <FontAwesomeIcon icon={faMapMarkerAlt} />{' '}
                          <a
                            href={`https://www.google.com/maps/search/${address}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {place || address}
                          </a>
                        </p>
                      )}
                      <p className="card-text">
                        <FontAwesomeIcon icon={faCalendarAlt} /> {start_at} -{' '}
                        {end_at}
                      </p>
                      <p className="card-text">
                        {last_post_date ? (
                          <Fragment>
                            <strong>Última publicação: </strong>
                            {last_post_date}
                          </Fragment>
                        ) : (
                          'Não tem publicações'
                        )}
                      </p>
                      <p className="card-text">
                        <strong>Divulgadores ativos:</strong> {active_promoters}
                      </p>
                      {benefits && (
                        <p className="card-text">
                          <strong>Benefícios:</strong> {benefits}
                        </p>
                      )}
                      {whatsapp_link && (
                        <p className="card-text">
                          <strong>Grupo no Whatsapp:</strong>{' '}
                          <a
                            href={`http://${whatsapp_link}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {whatsapp_link}
                          </a>
                        </p>
                      )}
                      {extra && (
                        <p className="card-text">
                          <strong>Mais informações:</strong> {extra}
                        </p>
                      )}
                      {rules && (
                        <p className="card-text">
                          <strong>Regras:</strong> {rules}
                        </p>
                      )}
                      <p className="card-text">
                        <strong>Vagas:</strong> {slots}
                      </p>
                      <p className="card-text">
                        <strong>Mínimo de seguidores:</strong> {min_followers}
                      </p>
                      {segment && (
                        <p className="card-text">
                          <strong>Segmento:</strong> {segment.name}
                        </p>
                      )}

                      <section>
                        <h5 className="section-title">Gerentes</h5>
                        <ManagerList>
                          {producers &&
                            producers.map(manager => (
                              <li key={manager.id}>
                                <strong>{manager.name}</strong> -{' '}
                                {this.roleTranslation[manager.role]}
                                {status === 'active' && manager.deletable && (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      this.deleteManager(manager.id)
                                    }
                                    className="delete-manager"
                                  >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                  </button>
                                )}
                              </li>
                            ))}
                        </ManagerList>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}

            <div
              className="modal fade"
              id="addManager"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="addManagerLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="addManagerLabel">
                      Adicionar gerente
                    </h5>
                    <button
                      id="closeManagerModal"
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={this.addManager}>
                      <div className="input-group">
                        <Input
                          type="email"
                          onChange={this.handleChange}
                          value={managerEmail}
                          name="managerEmail"
                          className="form-control"
                          placeholder="Email do gerente"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            Convidar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/EventDetail/index.js